import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CONTACT_INFO } from '../App';

const PrestationCocktail = () => {
  const galleryImages = [
    {
      src: "https://customer-assets.emergentagent.com/job_signature-studio-4/artifacts/4a6c6p84_cock.png",
      alt: "Cocktail signature orange"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_signature-studio-4/artifacts/3dbcl29z_ChatGPT%20Image%2030%20avr.%202026%20a%CC%80%2012_11_26.png",
      alt: "Barman préparant un cocktail champagne"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_signature-studio-4/artifacts/oh6vhv9j_ChatGPT%20Image%2029%20avr.%202026%20a%CC%80%2017_28_39.png",
      alt: "Barman avec shakers"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_signature-studio-4/artifacts/48ryxdtw_ChatGPT%20Image%2030%20avr.%202026%20a%CC%80%2016_46_36.png",
      alt: "Cocktail sur bar beige"
    }
  ];

  return (
    <div className="bg-black min-h-screen">
      {/* Hero with Background Image */}
      <section className="relative min-h-[60vh] flex items-center justify-center">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          <img
            src="https://customer-assets.emergentagent.com/job_signature-studio-4/artifacts/97dx63xo_ChatGPT%20Image%2030%20avr.%202026%20a%CC%80%2017_32_43.png"
            alt="Service Cocktail Background"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/60"></div>
        </div>
        
        {/* Content */}
        <div className="relative z-10 max-w-4xl mx-auto text-center px-6 lg:px-12 py-32">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <p className="text-sm uppercase tracking-wider text-white/70 mb-4">Prestation Cocktail</p>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-white mb-6">
              Service cocktail
            </h1>
            <div className="w-16 h-px bg-white/50 mx-auto"></div>
          </motion.div>
        </div>
      </section>

      {/* Introduction Text - WHITE SECTION */}
      <section className="section-white py-16 px-6 lg:px-12">
        <div className="max-w-3xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <p className="text-xl lg:text-2xl text-black leading-relaxed mb-6">
              STUDIO BAR propose des prestations cocktail clés en main, combinant service, création et mise en scène.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Nos équipes assurent une expérience fluide, élégante et adaptée à l'image de votre événement.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Services - WHITE SECTION with black cards */}
      <section className="section-white py-16 px-6 lg:px-12">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Barmen */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="p-8 bg-white border border-gray-200"
            >
              <p className="text-xl font-bold text-black mb-3">BARMEN</p>
              <p className="text-black leading-relaxed">
                Des barmen professionnels, formés à l'événementiel et à l'exigence du service haut de gamme.
              </p>
            </motion.div>

            {/* Cocktails */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="p-8 bg-white border border-gray-200"
            >
              <p className="text-xl font-bold text-black mb-3">COCKTAILS</p>
              <p className="text-black leading-relaxed">
                Une sélection de cocktails classiques et signatures, ou des créations sur mesure selon votre projet.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Gallery Section - BLACK SECTION */}
      <section className="bg-black py-24 px-6 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="font-display text-3xl lg:text-4xl text-white mb-4">
              Notre savoir-faire
            </h2>
            <p className="text-white/50">
              Un panel de créations et de services sur mesure
            </p>
          </motion.div>

          {/* Gallery Grid */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            {galleryImages.map((image, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="aspect-square overflow-hidden group"
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </motion.div>
            ))}
          </div>

          {/* Large Featured Image */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="mt-4 aspect-[21/9] overflow-hidden"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_signature-studio-4/artifacts/ev2j7asv_ChatGPT%20Image%2029%20avr.%202026%20a%CC%80%2010_16_10.png"
              alt="Service cocktail Studio Bar"
              className="w-full h-full object-cover object-center"
            />
          </motion.div>
        </div>
      </section>

    </div>
  );
};

export default PrestationCocktail;
